import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router, Route, Switch, Redirect } from "react-router-dom";

import UserModel from './components/UserModel';

import MainLayout from './MainLayout';

import AlertsScreen from './screens/AlertsScreen';
import AutoDetectionsScreen from './screens/AutoDetectionsScreen';
import AutoZoneDetectionsScreen from './screens/AutoZoneDetectionsScreen';
import AutoParkinglocationsScreen from './screens/AutoParkinglocationsScreen';
import HomeScreen from './screens/HomeScreen';
import CheckingOffensesScreen from './screens/CheckingOffensesScreen';
import CheckingParkingScreen from './screens/CheckingParkingScreen';
import CheckingSettingScreen from './screens/CheckingSettingScreen';
import MkaDetectionsScreen from './screens/MkaDetectionsScreen';
import MpaParkinglocationsScreen from './screens/MpaParkinglocationsScreen';
import EpoParkinglocationsScreen from './screens/EpoParkinglocationsScreen';
import ParkeonParkinglocationsScreen from './screens/ParkeonParkinglocationsScreen';
import SettingsParkinglocationsScreen from './screens/SettingsParkinglocationsScreen';
import SettingsParkinglocationPlacesScreen from './screens/SettingsParkinglocationPlacesScreen';
import SettingsParkinglocationGroupsScreen from './screens/SettingsParkinglocationGroupsScreen';
import SettingsPlaceRolesScreen from './screens/SettingsPlaceRolesScreen';
import TrafficSignsScreen from './screens/TrafficSignsScreen';
import TrafficSignsStatesScreen from './screens/TrafficSignsStatesScreen';
import TrafficSignsInfosScreen from './screens/TrafficSignsInfosScreen';
import TrafficSignsMessagesScreen from './screens/TrafficSignsMessagesScreen';
import TrafficSignsLogsScreen from './screens/TrafficSignsLogsScreen';
import TimeoutSignsScreen from './screens/TimeoutSignsScreen';
import TinyNodeSensorsScreen from './screens/TinyNodeSensorsScreen';
import TinyNodeInfrastructuresScreen from './screens/TinyNodeInfrastructuresScreen';
import TinyNodeDataScreen from './screens/TinyNodeDataScreen';
import TinyNodeMaintenanceScreen from './screens/TinyNodeMaintenanceScreen';
import TinyNodeMessagesScreen from './screens/TinyNodeMessagesScreen';
import TinyNodeParkinglocationsScreen from './screens/TinyNodeParkinglocationsScreen';
import UrbioticaParkinglocationsScreen from './screens/UrbioticaParkinglocationsScreen';
import UrbioticaSensorsScreen from './screens/UrbioticaSensorsScreen';
import UrbioticaMessagesScreen from './screens/UrbioticaMessagesScreen';
import UrbioticaTechMessagesScreen from './screens/UrbioticaTechMessagesScreen';
import CamdetectCamerasScreen from './screens/CamdetectCamerasScreen';
import CamdetectTechdatasScreen from './screens/CamdetectTechdatasScreen';
import CamdetectErrorsScreen from './screens/CamdetectErrorsScreen';
import CamdetectParkinglocationsScreen from './screens/CamdetectParkinglocationsScreen';
import SettingsServicesScreen from './screens/SettingsServicesScreen';
import SettingsUsersScreen from './screens/SettingsUsersScreen';
import SignInScreen from './screens/SignInScreen';
import NoMatchScreen from './screens/NoMatchScreen';

import { LocaleProvider } from 'antd';
import csCZ from 'antd/lib/locale-provider/cs_CZ';
import 'moment/locale/cs';

const SignedRoute = ({ component: Component, layout: Layout, ...rest }) => (
  <Route {...rest} render={props => (
    UserModel.isAuthenticated()
      ? <Layout>
        <LocaleProvider locale={csCZ}>
          <Component {...props} />
        </LocaleProvider>
      </Layout>
      : <Redirect
        to={{
          pathname: "/login",
          state: { from: props.location }
        }} />
  )} />
)

ReactDOM.render(
  <Router>
    <Switch>
      <SignedRoute layout={MainLayout} path="/" component={HomeScreen} exact />
      <SignedRoute layout={MainLayout} path="/checking/parkings" component={CheckingParkingScreen} />
      <SignedRoute layout={MainLayout} path="/checking/offenses" component={CheckingOffensesScreen} />
      <SignedRoute layout={MainLayout} path="/checking/settings" component={CheckingSettingScreen} />
      <SignedRoute layout={MainLayout} path="/parkdetect/detekce" component={AutoDetectionsScreen} />
      <SignedRoute layout={MainLayout} path="/parkdetect/detekce-zon" component={AutoZoneDetectionsScreen} />
      <SignedRoute layout={MainLayout} path="/parkdetect/parkinglocations" component={AutoParkinglocationsScreen} />
      <SignedRoute layout={MainLayout} path="/mka/detekce" component={MkaDetectionsScreen} />
      <SignedRoute layout={MainLayout} path="/mpa/parkinglocations" component={MpaParkinglocationsScreen} />
      <SignedRoute layout={MainLayout} path="/epo/parkinglocations" component={EpoParkinglocationsScreen} />
      <SignedRoute layout={MainLayout} path="/parkeon/parkinglocations" component={ParkeonParkinglocationsScreen} />
      <SignedRoute layout={MainLayout} path="/trafficsigns/list" component={TrafficSignsScreen} />
      <SignedRoute layout={MainLayout} path="/trafficsigns/states" component={TrafficSignsStatesScreen} />
      <SignedRoute layout={MainLayout} path="/trafficsigns/infos" component={TrafficSignsInfosScreen} />
      <SignedRoute layout={MainLayout} path="/trafficsigns/messages" component={TrafficSignsMessagesScreen} />
      <SignedRoute layout={MainLayout} path="/trafficsigns/logs" component={TrafficSignsLogsScreen} />
      <SignedRoute layout={MainLayout} path="/timeoutsigns/list" component={TimeoutSignsScreen} />
      <SignedRoute layout={MainLayout} path="/tinynode/sensors" component={TinyNodeSensorsScreen} />
      <SignedRoute layout={MainLayout} path="/tinynode/infrastructures" component={TinyNodeInfrastructuresScreen} />
      <SignedRoute layout={MainLayout} path="/tinynode/data" component={TinyNodeDataScreen} />
      <SignedRoute layout={MainLayout} path="/tinynode/maintenance" component={TinyNodeMaintenanceScreen} />
      <SignedRoute layout={MainLayout} path="/tinynode/messages" component={TinyNodeMessagesScreen} />
      <SignedRoute layout={MainLayout} path="/tinynode/parkinglocations" component={TinyNodeParkinglocationsScreen} />
      <SignedRoute layout={MainLayout} path="/urbiotica/sensors" component={UrbioticaSensorsScreen} />
      <SignedRoute layout={MainLayout} path="/urbiotica/messages" component={UrbioticaMessagesScreen} />
      <SignedRoute layout={MainLayout} path="/urbiotica/techmessages" component={UrbioticaTechMessagesScreen} />
      <SignedRoute layout={MainLayout} path="/urbiotica/parkinglocations" component={UrbioticaParkinglocationsScreen} />
      <SignedRoute layout={MainLayout} path="/camdetect/cameras" component={CamdetectCamerasScreen} />
      <SignedRoute layout={MainLayout} path="/camdetect/techdatas" component={CamdetectTechdatasScreen} />
      <SignedRoute layout={MainLayout} path="/camdetect/errors" component={CamdetectErrorsScreen} />
      <SignedRoute layout={MainLayout} path="/camdetect/parkinglocations" component={CamdetectParkinglocationsScreen} />
      <SignedRoute layout={MainLayout} path="/alerts/all" component={AlertsScreen} />
      <SignedRoute layout={MainLayout} path="/settings/parkinglocations" component={SettingsParkinglocationsScreen} />
      <SignedRoute layout={MainLayout} path="/settings/parkinglocation-places" component={SettingsParkinglocationPlacesScreen} />
      <SignedRoute layout={MainLayout} path="/settings/parkinglocation-groups" component={SettingsParkinglocationGroupsScreen} />
      <SignedRoute layout={MainLayout} path="/settings/place-roles" component={SettingsPlaceRolesScreen} />
      <SignedRoute layout={MainLayout} path="/settings/services" component={SettingsServicesScreen} />
      <SignedRoute layout={MainLayout} path="/settings/users" component={SettingsUsersScreen} />
      <Route path="/login" component={SignInScreen} />
      <Route component={NoMatchScreen} />
    </Switch>
  </Router>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js